import { Component, OnInit } from '@angular/core';
import { Project } from '../project'
import { RuntimeService } from '../runtime.service';
import { DbRecordService } from '../db-record.service';
import { DbRecord } from '../db-record';
import { RatingService } from '../rating.service'
import { ProjectService } from '../project.service'

@Component({
  selector: 'app-exclude-sources',
  templateUrl: './exclude-sources.component.html',
  styleUrls: ['./exclude-sources.component.css']
})
export class ExcludeSourcesComponent implements OnInit {
  isSelectMode = false;
  project: Project;
  rejectionMap = new Map<number, DbRecord[]>();
  currentSelectionNumber: number;
  currentSelectionRecords: DbRecord[];

  constructor(
    private projects: ProjectService,
    private rts: RuntimeService,
    private dbrs: DbRecordService,
    private rs: RatingService
  ) { }

  ngOnInit() {
  }

  switchMode() {
    this.isSelectMode = !this.isSelectMode;
    this.closeSelection();
  }

  get sourcesLs() {
    const ls = this.dbrs.getProjectSources(this.rts.currentProject);
    return ls.map((x, i) => {
      this.rejectionMap.set(i, x[1]);
      return [x[0], x[1].length, i];
    });
  }

  showSelection(nmb) {
    this.currentSelectionNumber = nmb;
    this.currentSelectionRecords = this.rejectionMap.get(nmb);
  }

  closeSelection() {
    this.currentSelectionNumber = undefined;
    this.currentSelectionRecords = undefined;
  }

  isSelected(nmb) {
    return nmb === this.currentSelectionNumber;
  }

  rejectRecords(tp, nmb) {
    const rLs = this.rejectionMap.get(nmb);
    const project = rLs[0].project;

    rLs.forEach(dbr => {
      project.ratingChange(dbr,
        'abstract',
        'rejected',
        tp,
        true
      )
    })

    this.projects.batchSaveRatings(project,
      rLs,
      'abstract',
      ['rejected', [tp]]
    ).subscribe(resp => {
      this.currentSelectionRecords = undefined;
      this.currentSelectionNumber = undefined;
    });
  }



  get rejectLs() {
    return this.rs.rejectAbstractValues;
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/exclude-sources/exclude-sources.component.ts